
export class ResetPasswordStore {

}

export const resetPasswordStore = new ResetPasswordStore();